
// import styled  from "styled-components"

import styled from "@emotion/styled";

export const Button = styled.button`
    background-color: rgb(228,0,43);
    padding: 11px 40px;
    border-radius: 200px;
    height: 44px;
    text-align: center;
    align-items: center;
    flex-direction: row;
    font-family: "National 2 Regular";
    font-style: normal;
    font-size: 14px;
    line-height: 24px;
    cursor: pointer;
    color: white;
    border: none;
`